module.exports = __webpack_public_path__ + "img/DCS_0001-21.3206d45f.jpg";